<template>
  <b-modal
    id="processingBooking"
    centered
    size="lg"
    :no-close-on-backdrop="true"
    :no-close-on-esc="true"
    :hide-footer="true"
    :hide-header="currentPage === 'product'"
    v-model="localIsProcessingBooking"
  >
    <template #toast-title>
      <div class="d-flex flex-grow-1 align-items-baseline" :dir="lang === 'he' ? 'rtl' : 'ltr'">
        <h3>{{ $t('booking.waiting') }}</h3>
      </div>
    </template>
    <div class="text-center" v-if="currentPage === 'product'">
      <img class="product" src="/assets/img/waiting.gif" alt="waiting" />
    </div>
    <div class="d-flex justify-content-between" :class="lang === 'he' ? 'text-right' : 'text-left'" v-else>
      <h5>{{ $t('booking.waiting-populating') }}</h5>
      <img src="/assets/img/waiting.gif" alt="waiting" />
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ProcessBookingModal',
  props: {
    currentPage: {
      type: String,
      required: true,
    },
    lang: {
      type: String,
      required: true,
    },
    isProcessingBooking: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      localIsProcessingBooking: this.isProcessingBooking, // Local copy of the prop
    };
  },
  watch: {
    isProcessingBooking(newVal) {
      this.localIsProcessingBooking = newVal; // Sync prop changes to local data
    },
    localIsProcessingBooking(newVal) {
      this.$emit('update:isProcessingBooking', newVal); // Emit changes to parent
    },
  },
};
</script>

<style>
#processingBooking + .modal-backdrop {
  opacity: 1;
  background-color: white;
}
#processingBooking .modal-content {
  box-shadow: #cac8c8 1px 1px 20px;
}
#processingBooking.ltr {
  direction: ltr;
}
#processingBooking.rtl {
  direction: rtl;
}
#processingBooking .modal-body h5 {
  padding: 35px 20px;
  font-size: 30px;
}
#processingBooking h3 {
  font-size: 22px;
  font-weight: 600;
  color: #313131;
  text-align: center;
}
#processingBooking.ltr {
  direction: ltr;
}
#processingBooking.rtl {
  direction: rtl;
}
#processingBooking .modal-body h5 {
  padding: 35px 20px;
  font-size: 30px;
}
#processingBooking img {
  width: 200px;
}
#processingBooking img.product {
  width: 400px;
}
#processingBooking h3 {
  font-size: 22px;
  font-weight: 600;
  color: #313131;
  text-align: center;
}
#b-toaster-top-center {
  top: 70px;
}
#processingBooking.modal .modal-dialog {
  display: flex;
  font-family: 'ploni', 'Poppins', sans-serif;
  font-weight: 500;
}
#processingBooking.modal:before {
  display: none;
}
#processingBooking.modal .modal-body {
  padding: 0px;
  margin: 0px;
}
@media (max-width:479px){
  #processingBooking img {
    width: 100px;
    height: 100px;
  }
  #processingBooking img.product {
    width: 100%;
    height: 100%;
  }
  #processingBooking .modal-body h5 {
    font-size: 20px;
  }
}
</style>
